'use client';

import {
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    SelectChangeEvent,
} from '@mui/material';
import {
    MuiMultiSelectPaperPropsStyles,
    MuiMultiSelectControlStyles
} from '../../utils/SelectStyles';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

interface Option {
    value: string;
    text: string;
}

interface Props {
    label: string;
    name: string;
    value: any;
    onChange: (e: SelectChangeEvent<string[]>) => void;
    options: Option[];
    selectedLabels: string[];
    error?: string | boolean;
    touched?: boolean;
    placeholder?: string;
    customIcon?: JSX.Element;
    open?: boolean;
    setOpen?: (val: boolean) => void;
    customStyles?: any
    disabled?: boolean
}

const MultiSelectDropdown = ({
    label,
    name,
    value,
    onChange,
    options,
    selectedLabels,
    error,
    touched,
    placeholder,
    customIcon,
    open,
    setOpen,
    customStyles,
    disabled
}: Props) => {
    const handleOpen = () => setOpen?.(true);
    const handleClose = () => setOpen?.(false);

    return (
        <div className='field_wrapper_container' style={customStyles || {}}>
            <div className='multi-select-wrapper input_wrapper w-full'>

                <div className="header">
                    <h5 className="title">{label}</h5>
                </div>

                <FormControl
                    sx={{
                        ...MuiMultiSelectControlStyles,
                        '& fieldset': {
                            borderColor: '#e5e5e5 !important',
                            borderWidth: '1px !important'
                        },
                        '&:hover fieldset': {
                            borderColor: '#e5e5e5'
                        }
                    }}
                // error={touched && Boolean(error)}
                >
                    {value.length === 0 && <InputLabel shrink={false}
                        style={{
                            lineHeight: 'unset',
                            fontSize: '0.9rem',
                            left: '0.5rem',
                            top: '0.1rem',
                            color: 'rgba(0,0,0,0.6)',
                        }}
                    >{placeholder}</InputLabel>}
                    <Select
                        multiple
                        open={open}
                        onOpen={handleOpen}
                        onClose={handleClose}
                        IconComponent={() => customIcon || null}
                        value={value}
                        onChange={onChange}
                        input={<OutlinedInput />}
                        renderValue={() => selectedLabels.join(', ')}
                        className={`select-drop-down ${error && touched && 'input-error'} ${disabled && 'disabled'}`}
                        disabled={disabled}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                                    width: 150,
                                    marginTop: '0.5rem',
                                    borderRadius: '8px'
                                }
                            },
                            sx: (theme) => ({ ...MuiMultiSelectPaperPropsStyles })
                        }}
                        inputProps={{ 'aria-label': 'Without label', name }}
                    >
                        {options?.map((option) => {
                            console.log(value, option?.value, value.indexOf(option?.value || ''), "testtesdt");
                            return (
                                <MenuItem
                                    key={option.text}
                                    value={option.value}
                                    sx={{
                                        '&.Mui-focusVisible': { backgroundColor: 'transparent' },
                                        '&.Mui-selected': {
                                            backgroundColor: '#c7c7c7 !important',
                                            color: 'black !important'
                                        },
                                        '&:hover': {
                                            backgroundColor: '#c7c7c7 !important',
                                            color: 'black !important'
                                        }
                                    }}
                                >
                                    <Checkbox
                                        sx={{'&.Mui-checked': {
                                            color: "black !important", // Checked color
                                        }}}
                                        checked={value.indexOf(option?.value || '') > -1} />
                                    <ListItemText primary={option.text} />
                                </MenuItem>
                            )
                        })}
                    </Select>
                    {touched && error && <p className='error'>{error}</p>}
                </FormControl>
            </div>
        </div>
    );
};

export default MultiSelectDropdown;